import { MyBookings, MyBookingsEndPoint } from './myBookings.interfaces';
import { delay } from '@shared/utils/async';
import { HttpEndpoint } from '@/api/httpEndpoints';
import { configBase } from '@/config/base';
import { MyBookingCredentials } from '../MyBookingCredentials/myBookingCredentials.interfaces';
import { fakeData } from './myBookings.fake';
import { getStoredFakeData } from '@/components/shared/DevPanel/DevPanel.helpers';
import fakeBookingsJSON from './myBookings.fake.json';

const stored = getStoredFakeData();

const myBookingsEndpoint = configBase.devMode.enabled
    ? 'mybooking'
    : 'https://booking-api.sembo.com/mybooking';

export class MyBookingsEndpoint extends HttpEndpoint implements MyBookingsEndPoint {
    public constructor(applicationUrl: string) {
        super(applicationUrl);
    }

    public async GetList(params: MyBookingCredentials): Promise<MyBookings> {
        const response = await this.get<MyBookings>(
            this.buildPathWithQuery(`${myBookingsEndpoint}/list`, {
                'api-version': '1.0',
            }),
            {
                withCredentials: true,
                headers: {
                    sessionId: params.sessionId,
                    sessionData: params.sessionData,
                },
            }
        );

        return response;
    }

    public async SendVerification(params: MyBookingCredentials): Promise<MyBookings> {
        const response = await this.post<MyBookings>(
            this.buildPathWithQuery(`${myBookingsEndpoint}/verification`, {
                'api-version': '1.0',
            }),
            {
                withCredentials: true,
                headers: {
                    sessionId: params.sessionId,
                    sessionData: params.sessionData,
                },
            }
        );

        return response;
    }
}

export class FakeMyBookingsEndpoint implements MyBookingsEndPoint {
    public async GetList(): Promise<MyBookings> {
        await delay(1500);

        if (!stored.bookings.isAuthenticated) {
            throw {
                response: {
                    status: 401,
                    message: 'Unauthorized',
                },
            };
        }

        const hasJSON = fakeBookingsJSON && Object.keys(fakeBookingsJSON).length > 0;

        return (hasJSON ? fakeBookingsJSON : fakeData) as MyBookings;
    }

    public async SendVerification(): Promise<any> {
        await delay(1500);

        return {};
    }
}
